import { render } from "./ImageRectOutline.vue?vue&type=template&id=60b4e2db&scoped=true&ts=true"
import script from "./ImageRectOutline.vue?vue&type=script&lang=ts"
export * from "./ImageRectOutline.vue?vue&type=script&lang=ts"

import "./ImageRectOutline.vue?vue&type=style&index=0&id=60b4e2db&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b4e2db"]])

export default __exports__